import { withFormik } from 'formik'

import { Experience }                          from '../../api'
import { InjectedStepperProps }                from '../organisms'
import { ExperiencesChunk }                    from './chunks'
import {
  genValueMapper,
  proxyFormikSubmission,
}                                              from './form-utils'
import { emptyExperiences, experiencesSchema } from './schemas'
import { asFormStep }                          from './wrappers'

interface Fields {
  experiences: Experience []
}

const formikConfig = {
  validationSchema: experiencesSchema,
  mapPropsToValues: genValueMapper(emptyExperiences),
  handleSubmit:     proxyFormikSubmission,
}

export default withFormik<InjectedStepperProps, Fields>(
  formikConfig,
)(
  asFormStep(
    ExperiencesChunk,
  ),
)



// WEBPACK FOOTER //
// ./src/components/forms/ExperienceFormStep.tsx